import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import {
  initializeCurrencySystem,
  validateCurrencyNotUAE,
} from "./utils/countryBasedCurrency";
import "./styles/App.css";

const App = () => {
  useEffect(() => {
    // Initialize country-based currency system on app startup
    const initCurrency = async () => {
      try {
        // Validate that currency is not UAE unless user is from UAE
        validateCurrencyNotUAE();

        // Initialize currency system based on country
        await initializeCurrencySystem();
      } catch (error) {
        console.error("Failed to initialize currency system:", error);
      }
    };

    initCurrency();
  }, []);

  return (
    <div className="app">
      <Outlet />
    </div>
  );
};

export default App;
